<template>
  <div class="infoBox">
    <el-button
      type="success"
      size="small"
      style="margin-bottom: 10px"
      plain
      @click="$router.push('/')"
      >{{ $t("category.jixugouwu") }}</el-button
    >
    <div class="detailBox">
      <div class="buttonBox" v-if="!isMobile">
        <div class="userName">{{ userDetail.name }}</div>
        <el-button
          icon="el-icon-goods"
          type="text"
          size="mini"
          style="width: 100%; color: #8eca56"
          @click="passVis = true"
          >{{ $t("info.xiugaimima") }}</el-button
        >
        <br />
        <el-button
          icon="el-icon-tickets"
          type="text"
          style="width: 100%; color: #8eca56"
          size="mini"
          @click="cardVis = true"
          >{{ $t("info.benrenquerenwenjiandengji") }}</el-button
        >
        <br />
        <el-button
          icon="el-icon-tickets"
          type="text"
          style="width: 100%; color: #8eca56"
          size="mini"
          @click="getOrder"
          >{{ $t("common.xiadanjilu") }}</el-button
        >
      </div>
      <div class="buttonBoxMobile" v-else>
        <div class="userName">{{ userDetail.name }}</div>
        <div style="width: 100%; display: flex; flex-wrap: wrap">
          <el-button
            icon="el-icon-goods"
            type="text"
            style="color: #8eca56; margin-right: 40px"
            @click="passVis = true"
            >{{ $t("info.xiugaimima") }}</el-button
          >
          <el-button
            icon="el-icon-tickets"
            type="text"
            style="color: #8eca56"
            @click="cardVis = true"
            >{{ $t("info.benrenquerenwenjiandengji") }}</el-button
          >
          <el-button
            icon="el-icon-tickets"
            type="text"
            style="color: #8eca56"
            @click="getOrder"
            >{{ $t("common.xiadanjilu") }}</el-button
          >
        </div>
      </div>
      <el-descriptions
        class="desBox"
        :title="`会员番号： ${userDetail.userId}`"
        :column="isMobile ? 1 : 2"
        size="small"
        border
      >
        <el-descriptions-item>
          <template slot="label">
            {{ $t("register.fapiaoyewubianma") }}
          </template>
          {{ userDetail.faPiaoId }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            {{ $t("register.youjiandizhi") }}
          </template>
          {{ userDetail.email }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            {{ $t("register.xingbie") }}
          </template>
          {{ userDetail.sex }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            {{ $t("register.shengrinianyueri") }}
          </template>
          {{ userDetail.birthday }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            {{ $t("register.dianhuafanhao") }}
          </template>
          {{ userDetail.telephone }}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">
            {{ $t("register.zhiye") }}
          </template>
          {{ userDetail.job }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            {{ $t("register.youbianfanhao") }}
          </template>
          {{ userDetail.postalCode }}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">
            {{ $t("register.zhusuo") }}
          </template>
          {{ userDetail.address }}
        </el-descriptions-item>
        <el-descriptions-item span="2">
          <template slot="label">
            {{ $t("info.benrenquerenwenjian") }}
          </template>
          {{
            userDetail.idAddressBack && userDetail.idAddressFront
              ? "已提出"
              : "未提出"
          }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- passVis Dialog -->
    <el-dialog
      :title="$t('info.xiugaimima')"
      :visible.sync="passVis"
      width="20%"
      @open="openPass"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="" prop="oldPass">
          <el-input
            :placeholder="$t('info.yuanmima')"
            v-model="ruleForm.oldPass"
          ></el-input>
        </el-form-item>

        <el-form-item label="" prop="newPass">
          <el-input
            :placeholder="$t('info.xinmima')"
            v-model="ruleForm.newPass"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passVis = false">{{
          $t("button.cancel")
        }}</el-button>
        <el-button type="primary" @click="surePass">{{
          $t("button.sure")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- card Dialog -->
    <el-dialog
      :title="$t('info.benrenquerenwenjiandengji')"
      :visible.sync="cardVis"
      width="40%"
    >
      <div class="cardBox">
        <el-upload
          class="avatar-uploader"
          :action="uploadSrc"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">前面</i>
        </el-upload>
        <el-upload
          class="avatar-uploader"
          :action="uploadSrc_back"
          :show-file-list="false"
          :on-success="handleAvatarSuccess_back"
        >
          <img v-if="imageUrl_back" :src="imageUrl_back" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon">背面</i>
        </el-upload>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="cardVis = false">{{
          $t("button.cancel")
        }}</el-button>
        <el-button type="primary" @click="sureCard">{{
          $t("button.sure")
        }}</el-button>
      </span> -->
    </el-dialog>

    <!-- 订单记录 -->
    <el-dialog
      :title="$t('common.xiadanjilu')"
      :visible.sync="isShowTable"
      @open="getOrder"
      :width="isMobile ? '90% !important' : ''"
    >
      <el-table :data="tableData" border stripe style="width: 100%">
<!--        <el-table-column prop="createTime" label="日付" type="expand">
          <template slot-scope="props">
            <div v-for="(i, k) in props.row.spus" :key="k" class="listBox">
              <img
                :src="baseUrl + i.spu.image"
                class="productImg"
                alt=""
                srcset=""
              />
              <div class="productInfo">
                <div style="font-size: 16px; font-weight: 600">
                  {{ i.spu.name }}
                </div>
                <div>モデル： {{ i.spu.title }}</div>
                <div>数量： {{ i.count }}</div>
                <div>合計価格：{{ i.price }}</div>
              </div>
            </div>
          </template>
        </el-table-column>-->
        <el-table-column label="予約番号">
          <template slot-scope="scope">
            <a @click="$router.push({ path: '/orderDetail', query: { props: scope.row } })">{{scope.row.orderId}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="spuNumber" label="商品数"> </el-table-column>
        <el-table-column prop="price" label="合計金額"> </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { userInfos, changePas, orderList } from "@/api/user";

export default {
  components: {},
  props: {},
  data() {
    return {
      baseUrl: "/proxyApi",
      isMobile: false,
      userDetail: {
        userId: "",
        address: "",
        birthday: "",
        email: "",
        faPiaoId: "",
        job: "",
        name: "",
        postalCode: "",
        sex: "",
        telephone: "",
        idAddressBack: "",
        idAddressFront: "",
      },
      passVis: false,
      ruleForm: {
        oldPass: "",
        newPass: "",
      },

      rules: {
        oldPass: [
          {
            required: true,
            message: this.$t("info.yuanmima"),
            trigger: "blur",
          },
        ],
        newPass: [
          { required: true, message: this.$t("info.xinmima"), trigger: "blur" },
        ],
      },

      uploadSrc: "/proxyApi/IdAddressFrontUpload",
      uploadSrc_back: "/proxyApi/IdAddressBackUpload",
      cardVis: false,
      imageUrl: "",
      imageUrl_back: "",

      isShowTable: false,
      tableData: [],
    };
  },
  created() {
    this.isMobile = this.checkIfMobile();
  },
  mounted() {
    userInfos().then((res) => {
      // console.log(res);
      this.userDetail = res.data;
      this.imageUrl = res.data.idAddressFront ? res.data.idAddressFront : "";
      this.imageUrl_back = res.data.idAddressBack ? res.data.idAddressBack : "";
    });
  },
  methods: {
    checkIfMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileAgents = [
        "android",
        "iphone",
        "ipad",
        "ipod",
        "blackberry",
        "windows phone",
      ];

      return mobileAgents.some((agent) => userAgent.includes(agent));
    },
    handleAvatarSuccess(res, file) {
      console.log(res, file);
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess_back(res, file) {
      console.log(res, file);
      this.imageUrl_back = URL.createObjectURL(file.raw);
    },
    sureCard() {},
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    openPass() {
      this.ruleForm.oldPass = "";
      this.ruleForm.newPass = "";
    },
    surePass() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let data = {
            email: this.userDetail.email,
            oldPassword: this.ruleForm.oldPass,
            newPassword: this.ruleForm.newPass,
          };
          changePas(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.message,
                type: "success",
              });

              this.passVis = false;
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    getOrder() {
      orderList().then((res) => {
        console.log(res);
        this.tableData = res.data;
      });
      this.isShowTable = true;
    },
  },
};
</script>
<style scoped>
.infoBox {
  width: 60%;
  padding: 20px;
  margin: 0 auto;

  box-sizing: border-box;
}
.detailBox {
  display: flex;
}
.userName {
  width: 100%;
  text-align: center;
  height: 100px;
  line-height: 100px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e7dddd;
}
.buttonBox {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
  padding: 20px;
  border: 1px solid #e7dddd;
}
.buttonBoxMobile {
  display: flex;
  flex-direction: row;
  width: 88%;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  /* border: 1px solid #e7dddd; */
}
.desBox {
  flex: 1;
}
.infoBox
  /deep/.el-descriptions--medium.is-bordered
  .el-descriptions-item__cell {
  padding: 30px !important;
}
.cardBox {
  display: flex;
  justify-content: space-around;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 22px;
  color: #8c939d;
  width: 240px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 240px;
  height: 178px;
  display: block;
}
.listBox {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px;
  border-bottom: 1px solid #f5f5f5;
}
.productInfo {
  line-height: 1.7;
  font-size: 12px;
}
.productImg {
  width: 90px;
  height: 90px;
  margin-right: 20px;
}

@media screen and (max-width: 768px) {
  .desBox,
  .infoBox {
    width: 100%;
  }
  .infoBox
    /deep/.el-descriptions--medium.is-bordered
    .el-descriptions-item__cell {
    padding: 10px !important;
  }
  .detailBox {
    flex-direction: column;
  }
  .userName {
    height: 30px;
    line-height: 30px;
    margin-bottom: 0px;
    border-bottom: 1px solid #e7dddd;
  }

  .cardBox {
    flex-direction: column;
  }
  .avatar-uploader {
    margin-top: 20px;
  }
  .avatar-uploader-icon {
    width: 260px;
    height: 120px;
    font-size: 16px;
    line-height: 120px;
  }
  .avatar {
    width: 260px;
    height: 120px;
  }
}
</style>